/**
 * 判断 metadata 返回的 STAFF 餐厅 string_id 数组是否包含有效绑定。
 * @param belongedRestaurant - metadata 中的餐厅 string_id 数组
 * @returns 至少包含一个非空 string_id 时为 true
 */
export function hasValidStaffRestaurantBinding(
    belongedRestaurant: unknown,
): belongedRestaurant is string[] {
    return Array.isArray(belongedRestaurant)
        && belongedRestaurant.some((stringId) => typeof stringId === 'string' && stringId.trim().length > 0);
}
